// components/dashboard/QuickActions.jsx
import React from 'react';
import { ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const QuickAction = ({ action }) => {
    const navigate = useNavigate();
    
    return (
        <button
            onClick={() => action.path && navigate(action.path)}
            className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all group w-full"
        >
            <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                    <div className="p-2 bg-[#F4F8E9] rounded-lg group-hover:bg-[#96B734] transition-colors">
                        {React.cloneElement(action.icon, {
                            className: "w-6 h-6 text-[#437011] group-hover:text-white"
                        })}
                    </div>
                    <span className="font-medium text-[#437011] group-hover:text-[#96B734]">
                        {action.label}
                    </span>
                </div>
                <ChevronRight className="w-5 h-5 text-[#96B734] group-hover:translate-x-1 transition-transform" />
            </div>
        </button>
    );
};

const QuickActions = ({ actions }) => (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {actions.map((action, index) => (
            <QuickAction key={index} action={action} />
        ))}
    </div>
);

export default QuickActions;